module.exports = __webpack_public_path__ + "img/StationBatteryFull.6b8b0425.svg";